import { ReactElement } from 'react'
import { TableCell } from '@mui/material'
import { t } from '../../i18n/services/i18n-translation-with-default'

export type DevelopusTreeTableItemCellType = {
  text: string
  color: string | undefined
  align: 'left' | 'center' | 'right'
  width?: number
}

interface Props {
  cell: DevelopusTreeTableItemCellType
}

const DevelopusTreeTableCell = (props: Props): ReactElement => {
  const { cell } = props
  const color = cell.color !== undefined ? cell.color : 'black'

  return (
    <TableCell style={{ width: cell.width ?? 'auto' }} align={cell.align}>
      <span style={{ color: color }}>
        {t(cell.text, { default: cell.text })}
      </span>
    </TableCell>
  )
}

export default DevelopusTreeTableCell
